import { careersHero } from '~/content/careers';
import { cn } from '~/lib/cn';

/** Staggered entrance matching the Webflow careers `#fade-in-*` keyframes. */
const fadeIn = (delayMs: number) =>
  ({
    animation: `careersFadeIn 0.4s ease both`,
    animationDelay: `${delayMs}ms`,
  }) as const;

export function CareersHero() {
  const { eyebrow, title, image } = careersHero;
  const srcSet = image.srcSet.map(({ src, width }) => `${src} ${width}w`).join(', ');

  return (
    <header className="overflow-hidden px-5 pt-[120px] pb-8 md:pb-12 lg:px-20 lg:pt-[148px] lg:pb-20">
      <style>{`
        @keyframes careersFadeIn {
          from { opacity: 0; transform: translateY(40px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @media (prefers-reduced-motion: reduce) {
          .careers-fade { animation: none !important; }
        }
      `}</style>
      <div className="relative mx-auto w-full max-w-[1280px]">
        <div className="mx-auto flex max-w-[330px] flex-col items-center text-center sm:max-w-[895px]">
          <p className={cn('careers-fade mb-6 text-[17px] text-ink-secondary')} style={fadeIn(100)}>
            {eyebrow}
          </p>
          <h1
            className={cn(
              'careers-fade mb-6 text-[36px] leading-[1.2] font-semibold tracking-[-0.02em] text-ink sm:text-[44px] lg:text-[64px]',
            )}
            style={fadeIn(150)}>
            {title}
          </h1>
        </div>
        <img
          className="careers-fade mt-[18px] h-auto w-full rounded-2xl sm:mt-6 sm:rounded-[20px] lg:mt-16"
          src={image.src}
          srcSet={srcSet}
          sizes="(max-width: 991px) 100vw, 1280px"
          width={2400}
          height={1600}
          alt={image.alt}
          loading="lazy"
          style={fadeIn(200)}
        />
      </div>
    </header>
  );
}
